import SearchOffIcon from '@mui/icons-material/SearchOff';
import { Button, Typography } from '@mui/material';
import { CenteredMui } from '@ui/utils';
import { FormattedMessage, useIntl } from 'react-intl';
import { useStatusQueryFilter } from '../hooks/useStatusQueryFilter';
import { StatusFilterType } from './options';

/**
 * Empty state message when no stations match the current filter in the status screen.
 * Uses the existing logger.statusScreen.count message with count 0 ("No stations found").
 * Includes a button to reset text and status filters.
 */
export function NoStationsFoundMessage() {
  const { $t } = useIntl();
  const { setQueryParams } = useStatusQueryFilter();

  const handleResetFilters = () => {
    setQueryParams({ text: '', status: StatusFilterType.ALL, type: null });
  };

  return (
    <CenteredMui>
      <SearchOffIcon sx={{ fontSize: 48, color: 'text.disabled', mb: 2 }} aria-hidden />
      <Typography variant="body1" color="text.disabled" sx={{ mb: 3 }}>
        <FormattedMessage
          id="logger.statusScreen.count"
          defaultMessage="{count, plural, =0 {Ninguna emisora encontrada} one {1 emisora encontrada} other {# emisoras encontradas} }"
          values={{ count: 0 }}
        />
      </Typography>
      <Button
        variant="outlined"
        size="small"
        onClick={handleResetFilters}
        aria-label={$t({
          id: 'logger.statusScreen.cleanFilters',
          defaultMessage: 'Limpiar filtros',
        })}
        sx={{
          color: 'text.secondary',
          borderColor: 'text.secondary',
          '&:hover': {
            borderColor: 'text.secondary',
            backgroundColor: 'action.hover',
          },
        }}
      >
        <FormattedMessage id="logger.statusScreen.cleanFilters" defaultMessage="Limpiar filtros" />
      </Button>
    </CenteredMui>
  );
}
